import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect
            fill="#FFEDD5"
            height="25"
            rx="2.5"
            stroke="#C2410C"
            width="25"
            x="3.5"
            y="3.5"
        />
        <path
            clip-rule="evenodd"
            d="M9.53195 16C9.53195 12.4278 12.4278 9.53195 16 9.53195C19.5722 9.53195 22.468 12.4278 22.468 16H23.968C23.968 11.5994 20.4006 8.03195 16 8.03195C11.5994 8.03195 8.03195 11.5994 8.03195 16C8.03195 20.4006 11.5994 23.968 16 23.968C16.4142 23.968 16.75 23.6323 16.75 23.218C16.75 22.8038 16.4142 22.468 16 22.468C12.4278 22.468 9.53195 19.5722 9.53195 16ZM16.7353 18.0127C17.0704 17.4048 17.218 16.5996 17.207 16.0288C17.1963 15.4724 17.0233 14.7753 16.698 14.2651C16.3999 13.7977 16.0595 13.5902 15.609 13.5902C14.7861 13.5902 13.5902 14.4127 13.5902 16C13.5902 17.869 14.7466 18.8008 15.609 18.8008C16.0709 18.8008 16.4238 18.5776 16.7353 18.0127ZM15.609 20.3008C16.6634 20.3008 17.4018 19.7479 17.8926 18.9972C18.0751 19.4136 18.3558 19.757 18.7079 20.0211C19.3247 20.4837 20.0997 20.6598 20.812 20.6598C21.6531 20.6598 22.4273 20.2486 22.973 19.7484C23.5015 19.2638 23.9681 18.552 23.9681 17.8045V16H22.4681V17.8045C22.4681 17.9593 22.3331 18.3001 21.9594 18.6426C21.6028 18.9695 21.174 19.1598 20.812 19.1598C20.3214 19.1598 19.8934 19.0351 19.6079 18.8211C19.3519 18.629 19.156 18.3283 19.156 17.8045V12.9925C19.156 12.5783 18.8202 12.2425 18.406 12.2425C17.9918 12.2425 17.656 12.5783 17.656 12.9925V13.0448C17.1674 12.4787 16.4946 12.0902 15.609 12.0902C13.948 12.0902 12.0902 13.594 12.0902 16C12.0902 18.406 13.6541 20.3008 15.609 20.3008Z"
            fill="#EA580C"
            fill-rule="evenodd"
        />
    </svg>
);

export default Icon;
